// ====== Acordeão técnico do produto ======
document.addEventListener('DOMContentLoaded', function() {
  const accordions = document.querySelectorAll('.accordion-title');

  accordions.forEach(btn => {
    btn.addEventListener('click', () => {
      const content = btn.nextElementSibling;
      const isOpen = btn.getAttribute('aria-expanded') === 'true';

      // Fecha todos os outros antes de abrir um novo (comportamento padrão de sanfona)
      document.querySelectorAll('.accordion-title').forEach(el => {
        el.setAttribute('aria-expanded', 'false');
        el.nextElementSibling.classList.remove('open');
      });

      // Alterna o atual
      btn.setAttribute('aria-expanded', !isOpen);
      content.classList.toggle('open', !isOpen);
    });
  });
});
